import { registerDecorator, type ValidationOptions } from 'class-validator';

export function isValidPec(value: string | undefined | null): boolean {
  if (!value) {
    return false;
  }
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
}

export function isValidSdi(value: string | undefined | null): boolean {
  return !!value && /^[A-Z0-9]{6,7}$/i.test(value);
}

function registerStringRule(
  name: string,
  message: string,
  rule: (value: string) => boolean,
  validationOptions?: ValidationOptions,
) {
  return (object: object, propertyName: string) => {
    registerDecorator({
      name,
      target: object.constructor,
      propertyName,
      options: validationOptions,
      validator: {
        validate: (value: unknown) => typeof value === 'string' && rule(value),
        defaultMessage: () => message,
      },
    });
  };
}

/** Validates a PEC address. Empty values are left to `@IsOptional`. */
export function IsPec(validationOptions?: ValidationOptions) {
  return registerStringRule('isPec', 'PEC non valida', isValidPec, validationOptions);
}

/** Validates an SDI recipient code (6 or 7 alphanumerics). */
export function IsSdiCode(validationOptions?: ValidationOptions) {
  return registerStringRule(
    'isSdiCode',
    'Codice SDI non valido (6 o 7 caratteri)',
    isValidSdi,
    validationOptions,
  );
}
